<h2 mat-dialog-title>Замена недоступной позиции</h2>

<div mat-dialog-content class="unavailable-products-dialog">
  <form [formGroup]="form" class="dialog-form">
    <mat-form-field appearance="outline">
      <mat-label>Фискальный счет</mat-label>
      <input matInput type="number" formControlName="source_invoice_id" />
    </mat-form-field>

    <div class="row-grid">
      <mat-form-field appearance="outline">
        <mat-label>ID товара к отмене</mat-label>
        <input matInput type="number" formControlName="cancel_product_id" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Количество</mat-label>
        <input matInput type="number" formControlName="cancel_quan" />
      </mat-form-field>
    </div>

    <div class="row-grid">
      <mat-form-field appearance="outline">
        <mat-label>ID товара замены</mat-label>
        <input matInput type="number" formControlName="replacement_product_id" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Количество</mat-label>
        <input matInput type="number" formControlName="replacement_quan" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Цена</mat-label>
        <input matInput type="number" formControlName="replacement_price" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Причина</mat-label>
      <textarea matInput formControlName="reason" rows="2"></textarea>
    </mat-form-field>
  </form>

  <div class="preview" *ngIf="preview">
    <div>
      <span>{{ preview.requires_credit_allocation ? 'Отмена позиций' : 'Фискальная отмена' }}</span>
      <strong>{{ supportService.formatMoney(preview.cancel_total) }}</strong>
    </div>
    <div>
      <span>{{ preview.requires_credit_allocation ? 'Уже зачтено в замену' : 'Перезачет' }}</span>
      <strong>{{ supportService.formatMoney(preview.credit_applied_total) }}</strong>
    </div>
    <p *ngIf="preview.requires_credit_allocation">Освободившиеся деньги останутся на балансе клиента. После проведения выберите сумму зачёта в счёт замены или оставьте средства свободными.</p>
    <div *ngIf="preview.requires_credit_allocation"><span>Освободится на баланс</span><strong>{{ supportService.formatMoney(preview.wallet_credit_potential || 0) }}</strong></div>
    <div>
      <span>{{ preview.requires_credit_allocation ? 'Счёт замены к оплате' : 'Доплата' }}</span>
      <strong>{{ supportService.formatMoney(preview.extra_payment_due_total) }}</strong>
    </div>
    <div>
      <span>К возврату</span>
      <strong>{{ supportService.formatMoney(preview.refund_due_total) }}</strong>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Закрыть</button>
  <button mat-stroked-button color="primary" type="button" (click)="previewReplacement()" [disabled]="loading || applying">
    Рассчитать
  </button>
  <button mat-flat-button color="primary" type="button" (click)="applyReplacement()" [disabled]="loading || applying">
    Провести
  </button>
</div>
